import { useEffect, useState } from "react";
import type { Language } from "../types";
import { languagesService } from "../services/languages-services";

const defaultLanguage: Language = {
  id: null,
  name: "",
  characterType: 1,
};

export const useFetchLanguage = (id: string | undefined, isCreate?: boolean): [Language | undefined, boolean] => {
  const [language, setLanguages] = useState<Language | undefined>(() => (isCreate ? defaultLanguage : undefined));
  const [isFetching, setIsFetching] = useState<boolean>(!isCreate);

  useEffect(() => {
    if (!id) {
      setIsFetching(false);
      return;
    }

    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response: Language = await languagesService.getLanguage(id!, abortController);

        setLanguages(response);
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    if (!isCreate) {
      fetchData();
    }

    return () => {
      abortController.abort();
    };
  }, [id, isCreate]);

  return [language, isFetching];
};
